var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, createStaticVNode as _createStaticVNode } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "page-block__box"
};
var _hoisted_2 = { class: "blank blank--md blank--column" };
var _hoisted_3 = { class: "blank__cover" };
var _hoisted_4 = {
    key: 0,
    class: "page-block__box"
};
var _hoisted_5 = { class: "page-block__box" };
var _hoisted_6 = { class: "page-block__box" };
var _hoisted_7 = { class: "under-cart" };
var _hoisted_8 = { class: "under-cart__wrap" };
var _hoisted_9 = ["innerHTML"];
import CartTable from "./components/products/CartTable.vue";
import Coupons from "./components/coupons/Coupons.vue";
import Gifts from "./components/gifts/Gifts.vue";
import TextPreloader from "../../components/TextPreloader.vue";
import Toast from "../../components/Toast.vue";
import Totals from "./components/Totals.vue";
import { useCartStore } from "./store";
import { storeToRefs } from "pinia";
import CartEventBus from "./CartEventBus";
import { ref } from "vue";
import Sprite from "../../components/Sprite.vue";
import { uniqueId } from "lodash-es";
import Toasts from "../../components/Toasts.vue";
import Atomizers from "./components/atomizers/Atomizers.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartApp',
    props: {
        atomizersAvailable: { type: Boolean, default: false },
    },
    setup: function (__props) {
        var store = useCartStore();
        var _a = storeToRefs(store), initialized = _a.initialized, coupons = _a.coupons, products = _a.products, giftable = _a.giftable, gifts = _a.gifts, giftsLeft = _a.giftsLeft, giftsUsed = _a.giftsUsed, vipAvailable = _a.vipAvailable, totalDiscount = _a.totalDiscount, totalSum = _a.totalSum;
        var showToast = ref(false);
        var loading = ref(false);
        var empty = ref(false);
        var warnings = ref([]);
        CartEventBus.on('loader:show', function () {
            showToast.value = true;
            setTimeout(function () { return loading.value = true; }, 10);
        });
        CartEventBus.on('loader:hide', function () { return loading.value = false; });
        CartEventBus.on('cart:empty', function () { return empty.value = true; });
        CartEventBus.on('warning:show', function (warning) {
            warnings.value.push({
                id: uniqueId('warning-'),
                text: warning,
            });
        });
        function removeWarning(id) {
            warnings.value = warnings.value.filter(function (warning) { return warning.id !== id; });
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (empty.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(Sprite, {
                                    name: "cart",
                                    size: 120,
                                    clear: ""
                                })
                            ]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "blank__text" }, "Ваша корзина пуста", -1 /* CACHED */))
                        ]),
                        _cache[3] || (_cache[3] = _createStaticVNode(" <div class=\"line line--jcc\"><div class=\"line__item\"><a href=\"/promotions/\" class=\"btn btn--1 btn--m btn--primary\"><span class=\"btn__label\">Наши акции</span></a></div> <div class=\"line__item\"><a href=\"/new/\" class=\"btn btn--2 btn--m btn--primary\"><span class=\"btn__label\">Новинки</span></a></div></div>", 2))
                    ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (__props.atomizersAvailable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(Atomizers)
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(CartTable, {
                                products: _unref(products),
                                gifts: _unref(gifts),
                                initialized: _unref(initialized)
                            }, null, 8 /* PROPS */, ["products", "gifts", "initialized"])
                        ]),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(Totals, {
                                        totalDiscount: _unref(totalDiscount),
                                        totalSum: _unref(totalSum),
                                        initialized: _unref(initialized)
                                    }, null, 8 /* PROPS */, ["totalDiscount", "totalSum", "initialized"]),
                                    _cache[4] || (_cache[4] = _createTextVNode()),
                                    _createVNode(Coupons, {
                                        coupons: _unref(coupons),
                                        loading: loading.value
                                    }, null, 8 /* PROPS */, ["coupons", "loading"]),
                                    _cache[5] || (_cache[5] = _createTextVNode()),
                                    _createVNode(Gifts, {
                                        giftable: _unref(giftable),
                                        gifts: _unref(gifts),
                                        giftsLeft: _unref(giftsLeft),
                                        giftsUsed: _unref(giftsUsed),
                                        vipAvailable: _unref(vipAvailable),
                                        orderSum: _unref(totalSum),
                                        minOrderSum: _unref(store).giftsMinOrderSum
                                    }, null, 8 /* PROPS */, ["giftable", "gifts", "giftsLeft", "giftsUsed", "vipAvailable", "orderSum", "minOrderSum"])
                                ])
                            ])
                        ])
                    ], 64 /* STABLE_FRAGMENT */)),
                _cache[11] || (_cache[11] = _createTextVNode()),
                _createVNode(Toasts, null, {
                    default: _withCtx(function () { return [
                        (showToast.value)
                            ? (_openBlock(), _createBlock(Toast, {
                                key: 0,
                                active: loading.value,
                                onClose: _cache[0] || (_cache[0] = function ($event) { return (showToast.value = false); })
                            }, {
                                icon: _withCtx(function () { return [
                                    _createVNode(TextPreloader)
                                ]; }),
                                default: _withCtx(function () { return __spreadArray([], __read((_cache[8] || (_cache[8] = [
                                    _createTextVNode("Обновление…", -1 /* CACHED */)
                                ]))), false); }),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["active"]))
                            : _createCommentVNode("v-if", true),
                        _cache[10] || (_cache[10] = _createTextVNode()),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(warnings.value, function (warning) {
                            return (_openBlock(), _createBlock(Toast, {
                                progress: "",
                                "auto-hide": "",
                                icon: "warning",
                                key: warning.id,
                                onClose: function ($event) { return (removeWarning(warning.id)); }
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("span", {
                                        innerHTML: warning.text
                                    }, null, 8 /* PROPS */, _hoisted_9)
                                ]; }),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClose"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]; }),
                    _: 1 /* STABLE */
                })
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
